export const images = {
  malcolmLightbody: {
    src: '/images/backgrounds/optimized/malcolm-lightbody-bngTyBvAkDM-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/malcolm-lightbody-bngTyBvAkDM-unsplash.small.webp',
    credit: 'Malcolm Lightbody',
    link: 'https://unsplash.com/@mlightbody?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#025370', // '#046A87'
  },

  alexDukhanov: {
    src: '/images/backgrounds/optimized/alex-dukhanov-MFM8ASk4XNs-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/alex-dukhanov-MFM8ASk4XNs-unsplash.small.webp',
    credit: 'Alex Dukhanov',
    link: 'https://unsplash.com/@argtone?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D4F1F7',
  },

  alexRainer: {
    src: '/images/backgrounds/optimized/alex_rainer-TF9vINyzZ5o-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/alex_rainer-TF9vINyzZ5o-unsplash.small.webp',
    credit: 'Alex Rainer',
    link: 'https://unsplash.com/@alex_rainer?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D2D2D2',
  },

  asoggetti: {
    src: '/images/backgrounds/optimized/asoggetti-uR6dIgDnt38-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/asoggetti-uR6dIgDnt38-unsplash.small.webp',
    credit: 'asoggetti',
    link: 'https://unsplash.com/@asoggetti?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#B8B1A5',
  },

  eberhardGrossgasteiger1: {
    src: '/images/backgrounds/optimized/eberhard-grossgasteiger-hQDx2S3aRLU-unsplash.webp',
    lowResSrc:
      '/images/backgrounds/optimized/eberhard-grossgasteiger-hQDx2S3aRLU-unsplash.small.webp',
    credit: 'Eberhard Grossgasteiger',
    link: 'https://unsplash.com/@eberhardgross?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D8DFED',
  },

  eberhardGrossgasteiger2: {
    src: '/images/backgrounds/optimized/eberhard-grossgasteiger-wZ8KKGUHxtU-unsplash.webp',
    lowResSrc:
      '/images/backgrounds/optimized/eberhard-grossgasteiger-wZ8KKGUHxtU-unsplash.small.webp',
    credit: 'Eberhard Grossgasteiger',
    link: 'https://unsplash.com/@eberhardgross?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#CFE9F2',
  },

  emreOzturk: {
    src: '/images/backgrounds/optimized/emre-ozturk-lfyKGQWEbew-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/emre-ozturk-lfyKGQWEbew-unsplash.small.webp',
    credit: 'Emre Öztürk',
    link: 'https://unsplash.com/@emreozturk?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#1C242D',
  },

  jonatanPie: {
    src: '/images/backgrounds/optimized/jonatan-pie-sQVXYkOVc18-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/jonatan-pie-sQVXYkOVc18-unsplash.small.webp',
    credit: 'Jonatan Pie',
    link: 'https://unsplash.com/@r3dmax?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#0F1C21',
  },

  nathanDumlao1: {
    src: '/images/backgrounds/optimized/nathan-dumlao-hlaXTWsu4G4-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/nathan-dumlao-hlaXTWsu4G4-unsplash.small.webp',
    credit: 'Nathan Dumlao',
    link: 'https://unsplash.com/@nate_dumlao?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D2D5D4',
  },

  nathanDumlao2: {
    src: '/images/backgrounds/optimized/nathan-dumlao-_tZAXBKwpn0-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/nathan-dumlao-_tZAXBKwpn0-unsplash.small.webp',
    credit: 'Nathan Dumlao',
    link: 'https://unsplash.com/@nate_dumlao?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D7D9DB',
  },

  noahAustin: {
    src: '/images/backgrounds/optimized/noah-austin-Y0so1JmsTAE-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/noah-austin-Y0so1JmsTAE-unsplash.small.webp',
    credit: 'Noah Austin',
    link: 'https://unsplash.com/@noah_austin?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#EDF6F7',
  },

  patrickSchneider: {
    src: '/images/backgrounds/optimized/patrick-schneider-I4fDK4Fz_vw-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/patrick-schneider-I4fDK4Fz_vw-unsplash.small.webp',
    credit: 'Patrick Schneider',
    link: 'https://unsplash.com/@patrick_schneider?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D4D0CC',
  },

  paysonWick: {
    src: '/images/backgrounds/optimized/payson-wick-B8VbQj7Y9WI-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/payson-wick-B8VbQj7Y9WI-unsplash.small.webp',
    credit: 'Payson Wick',
    link: 'https://unsplash.com/@paysonwick?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#A7B5C4',
  },

  szabolcsToth: {
    src: '/images/backgrounds/optimized/szabolcs-toth-MD786_d7Cyg-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/szabolcs-toth-MD786_d7Cyg-unsplash.small.webp',
    credit: 'Szabolcs Tóth',
    link: 'https://unsplash.com/@tothszabolcs?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#D3CBC5',
  },

  tomasMalik: {
    src: '/images/backgrounds/optimized/tomas-malik-ANCoz0JMhiQ-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/tomas-malik-ANCoz0JMhiQ-unsplash.small.webp',
    credit: 'Tomáš Malík',
    link: 'https://unsplash.com/@malcoo?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#B3BBCF',
  },

  whoisbenjamin: {
    src: '/images/backgrounds/optimized/whoisbenjamin-K-2J2Zq2n6c-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/whoisbenjamin-K-2J2Zq2n6c-unsplash.small.webp',
    credit: 'Whoisbenjamin',
    link: 'https://unsplash.com/@whoisbenjamin?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#A9B9B9',
  },

  zachLezniewicz: {
    src: '/images/backgrounds/optimized/zach-lezniewicz-o8cMgOUB-Z0-unsplash.webp',
    lowResSrc: '/images/backgrounds/optimized/zach-lezniewicz-o8cMgOUB-Z0-unsplash.small.webp',
    credit: 'Zach Lezniewicz',
    link: 'https://unsplash.com/@zachlez?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
    color: '#FFFFFF',
    background: '#1B1B1B',
  },
};

export const imageKeys = Object.keys(images);

const now = new Date().getTime();
export const nBackgrounds = imageKeys.length;
export const day =
  Number.parseInt((now - 1577836800000) / (1000 * 60 * 60 * 24), 10) % nBackgrounds;

export const imageOfTheDay = images[imageKeys[day]];
export default images;
